<template>
  <div>
    <p>{{ $t('Save this recovery password:') }}</p>
    <div class="mb-2">
      <div class="alert alert-secondary recovery-token">{{ formated }}</div>
    </div>
    <h5>{{ $t('Attention:') }}</h5>
    <div v-html="$t('save_2FA_password_text')"></div>
    <hr>
    <div class="form-check mb-3">
      <input
        class="form-check-input"
        type="checkbox"
        v-model="save_check"
        id="recovery_token_check">
      <label
        class="form-check-label"
        for="recovery_token_check">
        {{ $t('OK! I have already saved the recovery password in a safe place.') }}
        </label>
    </div>
    <button
      v-if="!recoveryInLogin"
      class="btn btn-primary"
      :disabled="!save_check"
      @click="checked()">
      {{ $t('Enable two-step verification') }}
    </button>
    <button
      v-if="recoveryInLogin"
      class="btn btn-primary"
      :disabled="!save_check"
      @click="checked()">
      {{ $t('Acessar') }}
    </button>
  </div>
</template>
  
<script>
  export default {
    name: 'ProfileTwofaSavepass',
    props: {
      value: {
        type: String,
        default: ''
      },
      recoveryInLogin: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        save_check: false
      }
    },
    computed: {
      formated () {
        const partes = this.value.match(/.{1,4}/g)
        return partes.join(' ')
      }
    },
    created () {
    },
    methods: {
      checked () {
        this.$emit('checked')
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.recovery-token {
  font-size: 1.3rem;
  letter-spacing: 0.08em;
  padding: 0.4rem 0.8rem;
  display: inline-block;
}
</style>



// WEBPACK FOOTER //
// src/components/Profile/ProfileTwofaSavepass.vue